
import { i18nText } from '@/locales';

import {Component, Prop, Vue} from 'vue-property-decorator';
import PageTitle from "@/UI/components/common/PageTitle.vue";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import {TablesStore} from "@/store/modules/Tables";
import {ITableColumn} from "@/entity/table/table.types";
import {message} from "ant-design-vue";
import {WorkersStore} from "@/store/modules/Workers";
import {IWorkers, IWorkersListItem} from "@/entity/workers/workers.types";
import WorkerAddForm from "@/form/workerAdd/workerAdd";
import {StatusesStore} from "@/store/modules/Status";
import {PositionStore} from "@/store/modules/Position";
import {SalaryStore} from "@/store/modules/Salary";
import {CategoryStore} from "@/store/modules/Category";
import {IPosition} from "@/entity/position/position.types";
import {IStatus} from "@/entity/status/status.types";
import {ICategory} from "@/entity/category/category.types";
import {ISalaryScheme} from "@/entity/salaryScheme/salaryScheme.types";
import ServiceCreateForm from "@/form/serviceCreate/serviceCreate";
import {ICms_Category} from '@/entity/staff/staff.types'

@Component({
    components: { PageTitle, FormGroup}
})
export default class ServiceCosmetologistLayout extends Vue {
    form = new ServiceCreateForm();
    workerForm = new WorkerAddForm();
    visible: boolean;
    staffAdded: Record<string, any>[];
    worker: IWorkersListItem | null = null;

    constructor() {
          super();
          this.visible = false;
          this.staffAdded = [];
    }

    // async saveStaff(){
    //     await this.form.submit(ServicesCategoryStore.create);
    // }

    show(staff: IWorkersListItem): void {
        this.worker = staff;
    }

    /*showStaff() {

        var staff    = WorkersStore.workers!.data;
        var cosmetologists = this.form.cosmetologists_id;

        for(let i = 0; i < staff.length; i++)
        {
            for(let j = 0; j < cosmetologists.length; j++)
            {
                if(staff[i].id == cosmetologists[j])
                {
                  this.staffAdded.push(staff[i])
                }
            }
        }
        this.visible = false;
    }*/

    showModal() {
      this.visible = true;
    }

    handleOk(e:any) {
      console.log(e);
      this.visible = false;
    }

    handleCancel(e:any) {
      this.visible = false;
    }

    deletedWorker(id:number) {
        var staff    = WorkersStore.workers!.data;
        //var cosmetologists = this.form.cosmetologists_id;

        for(let i = 0; i < staff.length; i++)
        {
            if(id == staff[i].id)
            {
                delete staff[i];
            }
        }
        /*for(let j = 0; j < cosmetologists.length; j++)
        {
            if(id == cosmetologists[j])
            {
                delete cosmetologists[j];
            } 
        }*/
    }

    get serviceWorkersColumns(): ITableColumn[] {
        return TablesStore.serviceWorkersColumns;
    }

    get staffLoaded(): boolean {
        return WorkersStore.workersLoaded;
    }
    get staff(): IWorkers | null {
        return WorkersStore.workers;
    }
    get positions(): IPosition[] {
        return PositionStore.position;
    }
    get statuses(): IStatus[] {
        return StatusesStore.status;
    }
    get categories(): ICms_Category[] {
        return CategoryStore.category;
    }
    get salary(): ISalaryScheme[] {
        return SalaryStore.salary;
    }

    async deleteWorker(id: number): Promise<void> {
    if ((await WorkersStore.delete(id)).status) {
        message.success(i18nText("Сотрудник успешно удален"));
        await WorkersStore.fetchAll({limit: 10, filter: {salon_id: parseInt(this.$route.params.id)}});
    } else  {
        message.error(i18nText("Что то пошло не так..."))
    }

    }
      async created(): Promise<void> {
        await WorkersStore.fetchAll({limit: 10});
        let res = WorkersStore.workers;
        console.log(res);
            await StatusesStore.fetchAll();
            await CategoryStore.fetchAll();
            await PositionStore.fetchAll();
            await SalaryStore.fetchAll();
            this.workerForm.setFormDataWithoutId(this.positions, this.categories, this.statuses, this.salary);
    }



}
